import React from 'react';
import { GentlemanJimMainLogoWrapper, GentlemanJimMainLogo } from './gentlemanjim.style';

export const GentlemanjimLogotype = (): JSX.Element => (
    <GentlemanJimMainLogoWrapper>
        <GentlemanJimMainLogo />
    </GentlemanJimMainLogoWrapper>
);
